import { DiscountProvider } from "@redotech/congo-enums/discount-provider";
import { RedoCheckbox } from "../../../arbiter-components/checkbox/redo-checkbox";
import { Flex } from "../../../flex";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { Text } from "../../../text";
import { ProductSelection } from "../../discount-shared";
import { CollectionsPicker, ProductsPicker } from "../pickers";

export function ItemRestrictionsField({
  excludeOnSale,
  onExcludeOnSale,
  specifyCollections,
  onSpecifyCollections,
  specifyProducts,
  onSpecifyProducts,
  collectionIds,
  setCollectionIds,
  selectedProducts,
  setSelectedProducts,
  provider,
}: {
  excludeOnSale: boolean;
  onExcludeOnSale: (checked: boolean) => void;
  specifyCollections: boolean;
  onSpecifyCollections?: (checked: boolean) => void;
  specifyProducts: boolean;
  onSpecifyProducts?: (checked: boolean) => void;
  collectionIds: string[];
  setCollectionIds: (ids: string[]) => void;
  selectedProducts: ProductSelection[];
  setSelectedProducts: (products: ProductSelection[]) => void;
  provider: DiscountProvider;
}) {
  return (
    <Flex mt="lg">
      <LabeledInput
        label={
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Item restrictions
          </Text>
        }
        size={LabelSize.EXTRA_SMALL}
      >
        <Flex dir="column" gap="md">
          {!specifyCollections && !specifyProducts && (
            <RedoCheckbox
              {...(provider === DiscountProvider.Shopifydiscount
                ? {
                    description:
                      "This will create a collection in Shopify to keep track of which items are not on sale.",
                  }
                : {})}
              label="Exclude on-sale items"
              setValue={(checked) => onExcludeOnSale(checked === true)}
              size="xs"
              value={excludeOnSale}
            />
          )}
          {!excludeOnSale && !specifyProducts && onSpecifyCollections && (
            <RedoCheckbox
              description="If enabled, the discount will only be applied to items in the specified collections."
              label="Limit to collections"
              setValue={(checked) => onSpecifyCollections(checked === true)}
              size="xs"
              value={specifyCollections}
            />
          )}
          {!excludeOnSale && !specifyCollections && onSpecifyProducts && (
            <RedoCheckbox
              description="If enabled, the discount will only be applied to the specified products."
              label="Limit to products"
              setValue={(checked) => onSpecifyProducts(checked === true)}
              size="xs"
              value={specifyProducts}
            />
          )}
        </Flex>

        {specifyCollections && onSpecifyCollections && (
          <CollectionsPicker
            collections={collectionIds}
            setCollections={setCollectionIds}
          />
        )}
        {specifyProducts && onSpecifyProducts && (
          <Flex mt="md">
            <ProductsPicker
              products={selectedProducts}
              setProducts={setSelectedProducts}
            />
          </Flex>
        )}
      </LabeledInput>
    </Flex>
  );
}
